import { HIGHLIGHT_COLORS, thumbWords } from "@/lib/thumbnail";

// Tap one word of the thumbnail text, then colour it yellow or red (tap White to clear).
export function HighlightPicker({ text, highlight, onChange }) {
  const words = thumbWords(text);
  if (!words.length) return null;
  const sel = highlight && highlight.index < words.length ? highlight.index : null;
  const pick = (i) => onChange(sel === i ? null : { index: i, color: highlight?.color || "yellow" });
  return (
    <div className="flex flex-col gap-2" data-testid="thumb-highlight-picker">
      <span className="text-xs text-zinc-500">Tap a word to make it pop</span>
      <div className="flex flex-wrap gap-1.5">
        {words.map((w, i) => (
          <button key={i} type="button" onClick={() => pick(i)} data-testid={`thumb-word-${i}`}
            className={`px-2.5 py-1 rounded-[4px] text-xs font-semibold border transition-colors ${sel === i ? "border-zinc-900 bg-zinc-900" : "border-zinc-200 hover:border-zinc-400 text-zinc-700"}`}
            style={sel === i ? { color: HIGHLIGHT_COLORS[highlight.color] } : undefined}>{w}</button>
        ))}
      </div>
      {sel !== null && (
        <div className="flex gap-2" data-testid="thumb-highlight-colors">
          {Object.entries(HIGHLIGHT_COLORS).map(([c, hex]) => (
            <button key={c} type="button" onClick={() => onChange({ index: sel, color: c })} data-testid={`thumb-highlight-${c}`}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-[4px] border text-xs capitalize transition-colors ${highlight.color === c ? "border-zinc-900" : "border-zinc-200 hover:border-zinc-400"}`}>
              <span className="w-3 h-3 rounded-full" style={{ background: hex }} /> {c}
            </button>
          ))}
          <button type="button" onClick={() => onChange(null)} data-testid="thumb-highlight-clear"
            className="px-3 py-1.5 rounded-[4px] border border-zinc-200 hover:border-zinc-400 text-xs transition-colors">White</button>
        </div>
      )}
    </div>
  );
}
